<template>
  <div class="onboard">
    <div class="onboard-header">
      <font-awesome-icon
        icon="arrow-left"
        class="back-btn"
        @click="prevPage"
        v-if="shouldShowPrevArrow"
      />
      <div></div>
      <font-awesome-icon
        icon="arrow-right"
        class="next-btn"
        @click="nextPageIfValid"
        v-if="!isLastPage"
        :class="{ disabled: !isNextButtonEnabled }"
      />
    </div>

    <onboard-page
      pageType="spotify"
      v-if="page === 1 && hasSpotify"
      @onEmpty="nextPage"
      :showInstructions="true"
    />
    <onboard-page
      pageType="popular"
      v-if="page === 2"
      :showInstructions="!hasSpotify"
    />

    <div class="bottom">
      <div
        class="continue-btn"
        @click="nextPageIfValid"
        :class="{ disabled: !isNextButtonEnabled, loading: buttonLoading }"
      >
        <span :class="{ loading: buttonLoading }"> {{ nextButtonTitle }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OnboardPage from "./OnboardPage.vue";
import ShopService from "@/services/ShopService";

export default {
  name: "Onboard",
  components: {
    OnboardPage,
  },
  data() {
    return {
      page: 1,
      buttonLoading: false,
    };
  },
  created() {
    if (!this.hasSpotify) {
      this.page = 2;
    }
  },
  computed: {
    ...mapGetters({
      hasSpotify: "auth/isSpotifyConnected",
      hasFollowedShops: "shop/hasFollowedShops",
      getFollowedShops: "shop/getFollowedShops",
    }),
    isFirstPage() {
      return this.page === 1;
    },
    isLastPage() {
      return this.page === 2;
    },
    shouldShowPrevArrow() {
      if (!this.hasSpotify) {
        return false;
      }

      return this.page != 1;
    },
    isNextButtonEnabled() {
      if (this.isFirstPage && !this.hasFollowedShops) {
        return false;
      }
      if (this.isLastPage && !this.hasFollowedShops) {
        return false;
      }
      return true;
    },
    nextButtonTitle() {
      if (this.isLastPage) {
        return "Let's get started";
      }

      if (this.isNextButtonEnabled) {
        return "Continue";
      } else {
        return "Select a few artists to get started";
      }
    },
  },
  methods: {
    prevPage() {
      this.page -= 1;
      this.trackEvent("Onboard", "Previous");
    },
    nextPage() {
      if (this.isLastPage) {
        this.buttonLoading = true;
        this.$store.dispatch("shop/followShops", this.getFollowedShops).then(
          (response) => {
            this.buttonLoading = false;
            this.$store.dispatch("auth/updateOnboardingStatus", true);
            this.$store.dispatch("onboard/clearOnboardInfo");
            this.trackEvent("Onboard", "Complete");
          },
          (error) => {
            this.buttonLoading = false;
            console.log("Error saving onboarding shops", error);
          }
        );
      } else {
        this.page += 1;
      }
    },
    nextPageIfValid() {
      if (this.isNextButtonEnabled) {
        this.trackEvent("Onboard", "Next");
        this.nextPage();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.onboard {
  width: 100%;
  // height: 100%;
  // height: 500px;
  height: calc(var(--vh, 1vh) * 100);
  flex: 1;
  // max-height: 500px;
  display: flex;
  flex-direction: column;

  overflow-x: hidden;
  padding-left: 0;
  color: white;
  padding-right: 0;
  background-color: #509bf5;
  background-image: linear-gradient(90deg, #1f637985 0%, #552f6da8 80%);
}

.bottom {
  padding: 10px;
  position: relative;
  width: 100%;
  @media (min-width: 768px) {
    width: 60%;
    margin: 0 auto;
  }
  .continue-btn {
    border-radius: 20px;
    background: #1db854;
    font-size: 14px;
    letter-spacing: 1px;
    font-weight: 400;
    line-height: 1.3;
    text-align: center;
    padding: 9px 30px 11px;
    color: #fff;
    cursor: pointer;
    &.disabled {
      pointer-events: none;
      cursor: default;
      background-color: #1db85499;
      color: #ccc;
    }
    &.loading::after {
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border: 4px solid transparent;
      border-top-color: #ffffff;
      border-radius: 50%;
      animation: button-loading-spinner 1s ease infinite;
    }
    span {
      &.loading {
        visibility: hidden;
      }
    }
  }
}
@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }
  to {
    transform: rotate(1turn);
  }
}

.onboard-header {
  display: flex;
  padding: 0 15px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  margin-top: 8px;
  @media (min-width: 992px) {
    margin-right: 20px;
    margin-top: 20px;
  }
  .back-btn {
    color: #fafafa;
    font-size: 1.5rem;
    @media (min-width: 992px) {
      font-size: 1.3rem;
    }
  }
  .next-btn {
    color: #fafafa;
    font-size: 1.5rem;
    &.disabled {
      pointer-events: none;
      cursor: default;
      color: #aaaaaaaa;
    }
    @media (min-width: 992px) {
      font-size: 1.3rem;
    }
  }
}
</style>
